import {useState, useCallback} from "react";

const DriverForm = () => {
    const [status, setStatus] = useState(""); // "ok" or "failed"
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        job: "",
        city: "",
        address: "",
        phone: "",
    });

    const handleChange = useCallback((e) => {
        const {name, value} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    }, []);

    const url = `https://darchasbcontact.pythonanywhere.com/contact/driver/`;

    const handleSubmit = useCallback(
        async (e) => {
            e.preventDefault();
            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                });
                if (response.ok) {
                    console.log("Form submitted successfully");
                    setStatus("ok");
                } else {
                    console.error("Form submission failed");
                    setStatus("failed");
                }
            } catch (error) {
                console.error("Error submitting form:", error);
                setStatus("failed");
            }
        },
        [formData, url]
    );

    // Define the form fields in an array to avoid repetitive code.
    const fields = [
        {
            id: "first_name",
            name: "first_name",
            type: "text",
            placeholder: "نام خود را وارد کنید...",
            label: "نام",
        },
        {
            id: "last_name",
            name: "last_name",
            type: "text",
            placeholder: "نام خانوادگی را وارد کنید...",
            label: "نام خانوادگی",
        },
        {
            id: "job",
            name: "job",
            type: "text",
            placeholder: "شغل خود را وارد کنید...",
            label: "شغل",
        },
        {
            id: "city",
            name: "city",
            type: "text",
            placeholder: "شهر خود را وارد کنید...",
            label: "شهر",
        },
        {
            id: "phone",
            name: "phone",
            type: "text",
            placeholder: "شماره همراه خود را وارد کنید...",
            label: "شماره همراه",
        },
        {id: "car", name: "car", label: "خودرو", placeholder: "نام خودرو و رنگ را وارد کنید..."},
        
        {
            id: "address",
            name: "address",
            type: "text",
            placeholder: "آدرس خود را وارد کنید...",
            label: "آدرس",
        },
    ];

    return (
        <div className="flex flex-col justify-center items-center py-36">
            <div className="mt-10 text-4xl">راننده شوید</div>
            <form
                onSubmit={handleSubmit}
                className="grid grid-cols-2 gap-10 max-md:mx-5 md:w-[900px] border border-gray-300 p-20 my-10 rounded-3xl bg-white"
            >
                {fields.map(({id, name, type, placeholder, label}) => (
                    <div
                        key={id}
                        className={`mb-5 max-md:col-span-2 ${name === "address" ? "col-span-2" : ""}`}
                    >
                        <label
                            htmlFor={id}
                            className="mb-3 block text-base font-medium text-gray-400 pl-2 text-right"
                        >
                            {label}
                        </label>
                        <input
                            type={type}
                            name={name}
                            id={id}
                            value={formData[name]}
                            onChange={handleChange}
                            placeholder={placeholder}
                            required  // This attribute ensures the field is required.
                            className="w-full border border-gray-300 rounded-xl py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:shadow-md"
                        />
                    </div>
                ))}
                <div/>

                {/* Full-width Submit Button */}
                <div className="max-md:col-span-2 col-span-2">
                    <button
                        type="submit"
                        className="w-full hover:shadow-form bg-gray-900 py-4 text-xl font-semibold text-white outline-none rounded-2xl hover:bg-gray-600 transition-all"
                    >
                        ثبت
                    </button>
                </div>

                {status === "failed" && (
                    <p className="max-md:col-span-2 text-red-400 bg-gray-50 rounded-2xl px-4 py-2">
                        ارسال فرم ناموفق بود
                    </p>
                )}
                {status === "ok" && (
                    <p className="max-md:col-span-2 text-green-400 bg-gray-50 rounded-2xl px-4 py-2">
                        فرم با موفقیت ارسال شد
                    </p>
                )}
            </form>
        </div>
    );
};

export default DriverForm;
